import { connectWithStore } from '../../../jsCore/utils/connectWithStore'
import { NavigationContainer } from './Navigation.container'
import { getTopAdHeight } from '../../../jsCore/store/topAd/topAd.selectors'
import { shouldShowNavigationInMobile } from '../../../jsCore/store/visibility/visibility.selectors'
import { mobileNavigationMenuClicked } from '../../../jsCore/organizedByType/actions/analyticsActions'

const mapDispatchToProps = {
  mobileNavigationAnalyticsMenuClicked: mobileNavigationMenuClicked,
}

const mapStateTpProps = (state, props) => ({
  topAdMargin: getTopAdHeight(state),
  shouldShowNavigation: shouldShowNavigationInMobile(state),
})

export const NavigationContainerWithStore = connectWithStore(
  NavigationContainer,
  mapStateTpProps,
  mapDispatchToProps
)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/navigation/NavigationWithStore.container.js